import { useState, useEffect } from 'react';

const useWatchlist = (tradeId, tradeState, isWatchlisted) => {
  const [watchList, setWatchList] = useState(isWatchlisted);

  useEffect(() => {
    if (typeof isWatchlisted === 'boolean') {
      setWatchList(isWatchlisted);
    }
  }, [isWatchlisted]);

  return [watchList, setWatchList];
};

export default useWatchlist;
